import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=57040309&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=57040309&prod&scoped=true&lang=css"
import style1 from "./DetailsModal.vue?vue&type=style&index=1&id=57040309&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57040309",
  null
  
)

export default component.exports